import { render } from "./StylistNav.vue?vue&type=template&id=a2bfe80c&scoped=true"
import script from "./StylistNav.vue?vue&type=script&lang=js"
export * from "./StylistNav.vue?vue&type=script&lang=js"

import "./StylistNav.vue?vue&type=style&index=0&id=a2bfe80c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2bfe80c"]])

export default __exports__